// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, onSnapshot } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBBJLgjNLl5KVSG9P178xGo9BsmEVs8N2U",
  authDomain: "shipra-app-2c8da.firebaseapp.com",
  projectId: "shipra-app-2c8da",
  storageBucket: "shipra-app-2c8da.firebasestorage.app",
  messagingSenderId: "352795901735",
  appId: "1:352795901735:web:f8e49b5924bb9d37427302",
  measurementId: "G-T0E769TZP6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Export for use in other files
export { db, collection, onSnapshot };
